module.exports = {
  "era": "era",
  "year": "year",
  "month": "month",
  "day": "day",
  "hour": "hour",
  "minute": "minute",
  "second": "second",
  "dayPeriod": "AM/PM",
  "calendar": "Calendar",
  "startDate": "Start Date",
  "endDate": "End Date",
  "weekday": "day of the week",
  "timeZoneName": "time zone",
  "selectedDateDescription": function selectedDateDescription(args) {
    return "Selected Date: ".concat(args.date);
  },
  "selectedRangeDescription": function selectedRangeDescription(args) {
    return "Selected Range: ".concat(args.startDate, " to ").concat(args.endDate);
  },
  "selectedTimeDescription": function selectedTimeDescription(args) {
    return "Selected Time: ".concat(args.time);
  }
};